import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import { history, useParams } from 'umi';
import { Layout, Tabs, Tab, TabPanel } from 'tea-component';
import ChangeDetail from './components/ChangeDetail';
import ChangeChecklist from './components/ChangeChecklist';
import { updateURLSearchParams } from '@intelligence/utils/commonUtils';
import { getMatchedValue, resetPageScrollTop } from '@gp/utils/common';
import { SEARCH_SELECT_COMP_AUTO_CLOSE_WHEN_SCROLL_NODE } from '@gp/constants/classNames';
import {
  CHANGE_DETAIL_TAB_CONFIG,
  CHANGE_CHECKLIST_TAB_CONFIG,
  CHANGE_LOG_DEFAULT_ACTIVE_ID,
} from './constants';

import type { ITab } from '@gp/types/global';

const { Content } = Layout;

const ChangeLog: React.FC = () => {
  const headerTitle = 'Change Log';
  const { tab: initialActiveId } = useParams() as any;
  const scrollBody = useRef(null);
  const [activeId, setActiveId] = useState<string>(() =>
    getMatchedValue({
      values: [CHANGE_DETAIL_TAB_CONFIG.key, CHANGE_CHECKLIST_TAB_CONFIG.key],
      defaultValue: CHANGE_LOG_DEFAULT_ACTIVE_ID,
      value: initialActiveId,
    }),
  );

  const tabs: ITab[] = [
    {
      id: CHANGE_DETAIL_TAB_CONFIG.key,
      label: CHANGE_DETAIL_TAB_CONFIG.title,
      disabled: false,
      component: <ChangeDetail scrollBody={scrollBody} headerTitle={headerTitle} />,
    },
    {
      id: CHANGE_CHECKLIST_TAB_CONFIG.key,
      label: CHANGE_CHECKLIST_TAB_CONFIG.title,
      disabled: false,
      component: <ChangeChecklist scrollBody={scrollBody} headerTitle={headerTitle} />,
    },
  ];

  const tab = tabs?.find((tab) => tab?.id === activeId);

  const handleActive = (tab: Tab) => {
    const activeIdTmp = tab?.id || CHANGE_DETAIL_TAB_CONFIG.key;
    updateURLSearchParams({}, ['short_url_key']);
    setActiveId(activeIdTmp);
    resetPageScrollTop(document.querySelector('.dbg-pipeline-change-log-page'));
    history.replace(`/g-pop/Pipeline/ChangeLog/${activeIdTmp}${location.search || ''}`);
  };

  useEffect(() => {
    resetPageScrollTop(document.querySelector('.dbg-pipeline-change-log-page'));
    history.replace(`/g-pop/Pipeline/ChangeLog/${activeId}${location.search || ''}`);
  }, []);

  return (
    <Content
      className="dbg-initial-line-height dbg-tab-page dbg-pipeline-change-log-page dbg-page-scroll-body"
      ref={scrollBody}
    >
      <Content.Header className="dbg-tab-page__header" title={headerTitle}>
        <Tabs
          className="dbg-tab-page__tabs"
          ceiling
          tabs={tabs}
          activeId={activeId}
          onActive={handleActive}
        />
      </Content.Header>
      <Content.Body
        full
        className={classnames(
          'dbg-tab-page__body dbg-pipeline-change-log-table-page__body',
          SEARCH_SELECT_COMP_AUTO_CLOSE_WHEN_SCROLL_NODE,
        )}
      >
        <TabPanel key={tab?.id} id={tab?.id || ''}>
          {React.cloneElement(tab?.component as React.ReactElement, {})}
        </TabPanel>
      </Content.Body>
    </Content>
  );
};

export default ChangeLog;
